<div class="card card-clickable card-sm h-100" (click)="open()">
  <div class="card-body">
    <div class="mb-4">
      <span class="tag">{{ tag }}</span>
    </div>

    <h4>
      {{ headline }}
    </h4>

    <div class="mb-0">
		<ng-content></ng-content>
    </div>

    <span class="fw-bold d-inline-block mt-3"><i class="fa-sharp fa-solid fa-arrow-right me-2"></i>
      <u>Mehr erfahren</u>
    </span>
  </div>
</div>
